import { observer } from "mobx-react-lite";
import { useIsMobile, useTran } from "@/hooks";
import { LanguageSwitcher } from "@/components/common";
import { LoginForm } from "../components";

const AuthPage = observer(() => {
  const isMobile = useIsMobile();
  const { t } = useTran();

  if (isMobile) {
    return (
      <div className="relative h-screen min-h-[100dvh] overflow-hidden bg-background">
        <div className="absolute left-4 top-4 z-20">
          <img
            src="/logos/logo.svg"
            alt={t("NxStart Logo")}
            className="h-10 w-auto sm:h-12"
          />
        </div>

        <div className="absolute right-4 top-4 z-20">
          <LanguageSwitcher />
        </div>

        <div className="flex h-full items-center justify-center px-4 pb-6 pt-20">
          <div className="w-full max-w-sm rounded-[28px] bg-white p-6 shadow-[0_20px_50px_rgba(15,23,42,0.14)]">
            <LoginForm variant="mobile" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="relative h-screen min-h-[100dvh] overflow-hidden bg-background">
      <div className="absolute left-10 top-7 z-20">
        <img
          src="/logos/logo.svg"
          alt={t("NxStart Logo")}
          className="h-12 w-auto"
        />
      </div>

      <div className="absolute right-10 top-7 z-20">
        <LanguageSwitcher />
      </div>

      <div className="flex h-full items-center justify-center px-6">
        <div className="grid h-[500px] w-full max-w-3xl grid-cols-[46%_54%] overflow-hidden rounded-[34px] shadow-[0_26px_60px_rgba(15,23,42,0.16)]">
          <section className="relative overflow-hidden bg-card">
            <div className="absolute inset-y-0 left-0 w-full rounded-r-[150px] bg-gradient-to-b from-primary to-secondary" />

            <div className="relative z-10 flex h-full items-center justify-center px-12">
              <div className="max-w-[330px] text-center text-white">
                <h1 className="mb-5 text-4xl font-bold leading-none">
                  {t("Hello, Welcome!")}
                </h1>
                <p className="text-white/95">
                  {t(
                    "Thank you for joining our journey! Together, we can create a better future. Explore, engage, and be a part of something meaningful.",
                  )}
                </p>
              </div>
            </div>
          </section>

          <section className="flex items-center justify-center bg-card px-12">
            <LoginForm variant="panel" />
          </section>
        </div>
      </div>
    </div>
  );
});

export default AuthPage;
